import { AxiosError } from 'axios';
import { ErrorCodes } from '@ringana/errors';
import { ITranslatable } from '@/common/interfaces/api.interface';
import ApiRoutes from '../api/ApiRoutes';
import { EErrorMessage } from '@/common/enums/messages.enum';

export default class FetchError extends Error {
  public details: (string | ITranslatable)[];

  constructor(public readonly errorCode: ErrorCodes,
              public readonly axiosError: AxiosError,
              public readonly apiRoute: ApiRoutes) {
    super(axiosError?.response?.data?.message ? axiosError.response.data.message : EErrorMessage.FETCH_UNEXPECTED);
    Object.setPrototypeOf(this, FetchError.prototype);

    this.details = axiosError.response?.data.details ?? [];
  }
}
